import { Pipe, PipeTransform } from '@angular/core';
import { PatientInfoAPI } from 'src/app/features/medical-record/medical-record-page/pages/patient-informations/model/patient.model';

@Pipe({
  name: 'physicalDisability'
})
export class PhysicalDisability implements PipeTransform {

  transform(items?: PatientInfoAPI['physicalDisability'] | null, ...args: unknown[]) {

    if (!items ) {
      return null
    }

    return items
      .filter( x => x.value ) // 'value' guarda se tem ou nao essa defic
      .map( x => x.disability ) // 'disability' guarda nome da prop
      .join(', ')
  }

}
